import EnterRecoveryFreespins from "slotworks/state-machine/standard/states/enter-recovery-freespins";
import gameState from "slotworks/model/game-state";
import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";
import { ShowFreespinsElements } from "commands/freespins";
import rainbowStacksComponents from "components/components";
import { HideUIButtons } from "commands/ui-buttons";
import soundManager from "slotworks/sound/sound-manager";

export default class RainbowStacksEnterRecoveryFreespins extends EnterRecoveryFreespins {

    public onEnter() {
        gameState.getCurrentGame().inFreespinsGame = true;
        HideUIButtons();
        super.onEnter();        
    }

    public complete() {
        soundManager.customEvent("freespins_music");
        super.complete();
    }

    protected recoverFreespinsElements() {
        ShowFreespinsElements();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/enter-recovery-freespins.ts